import { gql, GraphQLClient } from 'graphql-request';

import type { Country } from '@widget/types';

const graphQLClient = new GraphQLClient('/api/places');

const PlacesQuery = gql`
  query getPlaces($searchWord: String!, $country: Country!, $limit: Int!) {
    places(input: { searchWord: $searchWord, country: $country, limit: $limit }) {
      id
      displayName
    }
  }
`;

export type PlaceItem = {
  id: number;
  displayName: string;
};

export async function getPlacesQuery(search: string, countries: Country[] = ['de']) {
  const responses = await Promise.allSettled(
    countries.map((country) =>
      graphQLClient.request<{ places: PlaceItem[] }>(PlacesQuery, {
        searchWord: search,
        country: country.toUpperCase(),
        limit: 5,
      }),
    ),
  );

  return responses.flatMap((response) =>
    response.status === 'rejected' ? ([] as PlaceItem[]) : response.value.places,
  );
}
